import type { IFilter } from "../constants/filter-types";

/**
 * The filters with each name once, keeping the first. The modal joins the general catalog with a
 * source's own, and both offer "In campaign" (PREC-4163); a name shown twice would also share one
 * stored condition, so the second entry could only ever mirror the first.
 */
export const uniqueFiltersByName = <T extends Pick<IFilter, "name">>(filters: T[]): T[] => {
	const seen = new Set<string>();

	return filters.filter((filter) => {
		if (seen.has(filter.name)) {
			return false;
		}

		seen.add(filter.name);

		return true;
	});
};
